import { render, staticRenderFns } from "./ProductsV2.vue?vue&type=template&id=6f2879e0&scoped=true"
import script from "./ProductsV2.vue?vue&type=script&lang=js"
export * from "./ProductsV2.vue?vue&type=script&lang=js"
import style0 from "./ProductsV2.vue?vue&type=style&index=0&id=6f2879e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2879e0",
  null
  
)

export default component.exports